export default "__VITE_ASSET__CCYmxceH__"